

















import ContentComponent from "./ContentComponent.vue";
import OldContentComponent from '@/dex-shared/components/content/ContentComponent.vue';
import { PropType } from 'vue';
import ContentModel from '@/dex-shared/models/ContentModel';
export default {
  components: {
    ContentComponent,
    OldContentComponent
  },
  props: {
    contents: {
      required: true
    },
    context: {
      type: String,
      required: false,
      default: null,
      validator: function (value:string) {
        return [
          "question", "solution", "article", "assertion", "essay_reply"
        ].includes(value)
      }
    },
    trustedContent: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    totalLength: () => {
      return this.contents.reduce(
        (acc:number, content:ContentModel) => acc + content.length(),
        0
      )
    } 
  },
  methods: {
    questionSize() {
      if (this.context != "question") {
        return "";
      }
      if (this.totalLength > 240) {
        return "question-large";
      }
      if (this.totalLength > 140) {
        return "question-medium";
      }
      return "question-small";
    }
  }
};
